<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="编辑信息" name="0"></el-tab-pane>
            <el-tab-pane label="信息单" name="1"></el-tab-pane>
        </el-tabs>
        <swb-devc-info-form-list v-if="activeName == '1'" :devcId="deviceSubNoId" :devcNo="tmpNo"></swb-devc-info-form-list>
        <swb-shop-device-svcSubNo-edit name="result_table" :devcId="deviceSubNoId" ref="shop_device_svcSubNo_edit" v-else></swb-shop-device-svcSubNo-edit>
        <div class="form-toolbar" v-if="activeName == '0'">
            <button class="swb-btn swb-btn-small mr10" @click="doShopDeviceEdit()">确定</button>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import devcApi from '../../api/devc'

    import SwbShopDeviceSvcSubNoEdit from './ShopDeviceSvcSubNoEdit'
    Vue.regist(SwbShopDeviceSvcSubNoEdit);

    import SwbDevcInfoFormList from './DevcInfoFormList'
    Vue.regist(SwbDevcInfoFormList);

    export default {
        name: 'swb-shop-device-edit-info-dlg',
        desc: '资产明细编辑',
        props: {
            deviceSubNoId: {
                type: Number,
                default: null
            },
            tmpNo: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                theTableHeight: 408,
                //
                activeName: '0'
            }
        },
        created: function () {
            //
        },
        mounted() {
        },
        methods: {
            handleClick(){
//                let parentDlg = Vue.$getClassInfo(this).parent;
//                if(this.activeName == '0') {
//                    parentDlg.okVisible = true;
//                    parentDlg.cancelText = '取消';
//                } else {
//                    parentDlg.okVisible = false;
//                }
            },
            // 设备编辑
            doShopDeviceEdit: function () {
                let self = this;
                let result = self.$refs.shop_device_svcSubNo_edit.getDlgResult();
                if(!Utils.isNoB(result)){
                    if(result.type == 'info') {
                        let postData = result.data;
                        if(!Utils.isNoB(postData)) {
                            let theLoad = MsgBox.loading();
                            devcApi.updateShopDevice(postData, function (result) {
                                theLoad.hide();
                                if(result.type === "info") {
                                    MsgBox.success("操作成功！");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceEditInfo.vue